import List from './List'
import * as actCustomerList from 'actions/customers/list'
import ActionBar from './ActionBar'
import ImportModal from './importModal'
import ImportModalError from './importModalError'
import {connect} from 'react-redux'
import styles from './CustomerList.css'
import CustomerDetail from './CustomerDetail'
import {doImportCustomer, showModalImport, showModalErrorImport} from 'actions/uploaders'
import NoDataAndLoading from 'components/NoDataAndLoading'
import ImportingModeModal from './ImportingModeModal'
import {browserHistory} from 'react-router'
import * as mpCustomerList from 'mixpanel/customers/list'

class CustomerList extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    const expireTime = 365 // expire time 1 year
    if (!expired) {
      this.props.dispatch(actCustomerList.pageRequest())
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', {path: '/', domain: '.mokapos.com', expires: expireTime})
      }
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let { showModalImport, showModalErrorImport, messageError } = this.props.data.uploaders.import
    let { showLoadingButton } = this.props.data.buttons
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner
    let {customers} = this.props.data.customers.list

    return (
      <div id='customer-list' className={styles.wrapper}>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport}
        />
        <div className={`row ${styles['mk-customer-list']}`}>
          <div className={`col-sm-12 col-md-12 ${styles['left-column']}`} id='mk-col-left'>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={customers.length === 0}
              title='No Data To Display'
              description='' />
            <List />
          </div>
          <div className={`col-sm-12 ${styles['right-column']}`} id='mk-col-right'>
            <CustomerDetail
              onClickDone={this._closeCustomerDetail}
            />
          </div>
        </div>
        <ImportModal
          onShow={showModalImport}
          onHide={this._onClickCancelImport}
          onUpload={this._onClickUploadButton}
          showLoadingButton={showLoadingButton}
          onClickDownloadTemplate={this._onClickDownloadTemplate}
          changeModalVisibility={this._changeModalVisibility}
        />
        <ImportModalError
          onShow={showModalErrorImport}
          messageError={messageError}
          onClickTryBtn={this._onClickTryBtn}
          onClickCancelBtnError={this._onClickCancelBtnError}
          onClickDownloadTemplate={this._onClickDownloadTemplate}
        />
        <ImportingModeModal />
      </div>
    )
  }

  _onClickTryBtn = () => {
    this.props.dispatch(showModalImport(true))
    this.props.dispatch(showModalErrorImport(false, []))
  }

  _onClickCancelBtnError = () => {
    this.props.dispatch(showModalImport(false))
    this.props.dispatch(showModalErrorImport(false, []))
  }

  _onClickExport = () => {
    let userEmail = this.props.data.moka.user.email
    let filename = 'Customer List - ' + userEmail
    mpCustomerList.customerListExport()
    this.props.dispatch(actCustomerList.customerExportRequest(filename))
  }

  _onClickImport = () => {
    this.props.dispatch(showModalImport(true))
  }

  _onClickCancelImport = () => {
    this.props.dispatch(showModalImport(false))
  }

  _onClickUploadButton = (file) => {
    this.props.dispatch(doImportCustomer(file))
  }

  _changeModalVisibility = () => {
    let { showModalImport } = this.props.data.uploaders.import
    this.props.dispatch(actCustomerList.changeModalVisibility(!showModalImport))
  }

  _closeCustomerDetail = () => {
    if ($('#customer-detail').is(':visible')) {
      this.props.dispatch(actCustomerList.closeCustomerDetail()) // back to list customers
    } else {
      // back to customer detail
      $('#receipt-invoice-customer').hide()
      $('#receipt-transaction-customer').hide()
      $('#customer-detail').show()
    }
  }
  _onClickDownloadTemplate = () => {
    let userEmail = this.props.data.moka.user.email
    let filename = 'Customer List - ' + userEmail
    this.props.dispatch(actCustomerList.downloadCustomerTemplate(filename))
  }
}

function mapStateToProps (state) {
  return {
    data: state
  }
}

export default connect(mapStateToProps)(CustomerList)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListNonLoyalty/CustomerList.js